import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import React , {Component} from 'react';
import firebase from 'firebase';
import ModalCalificaciones from './ModalCalificaciones';
import Modal from 'react-modal';
import Alert from 'react-s-alert';
import store from '../../store';

const database=firebase.database();


const customStyles = {
  content : {
    top                   : '50%',
    left                  : '50%',
    right                 : 'auto',
    bottom                : 'auto',
    transform             : 'translate(-50%, -50%)',
	width                 : '700px'
	
  }
};

class Calificaciones extends Component{
	
	
	constructor(props)
	{
		
		super(props);
		this.state={
			isActive:false,
			estado:'',
			pregunta:'',
			tipo:'',
			calificaciones:[],
			preguntas:[],
			preguntasAgregar:[],
			preguntasEliminar:[],
			estado_pregunta:'',
			template:false
			
		}

		this.tipo_calificaciones=database.ref().child('tipo_calificaciones');
		this.Calificaciones=database.ref().child('Calificaciones');
		this.toggleModal=this.toggleModal.bind(this);
		this.handleClick=this.handleClick.bind(this);
		this.handleSubmit=this.handleSubmit.bind(this);
		this.handleClickEliminarPregunta=this.handleClickEliminarPregunta.bind(this);
		this.handleClickAgregarPregunta=this.handleClickAgregarPregunta.bind(this);
		this.ocultarMenu=this.ocultarMenu.bind(this);
		this.handleClickAlerta=this.handleClickAlerta.bind(this);
		this.handleClickClose=this.handleClickClose.bind(this);
		this.updateRow=this.updateRow.bind(this);
		
		
		this.AlertaContenido = ({
		  id,
		  classNames,
		  styles,
		  message,
		  customFields,
		  handleClose,
		}) => {
		const handleConfirm = () => {
			
			
			
			this.handleSubmit();		
			Alert.close(id);
			this.setState({
				template:false
			})
		}
			return (
			<div className={classNames} id={id} style={styles}>
			  <div className='s-alert-box-inner'>
					{message}
			  </div>
			  <br/>
			  <br/>
			  <button className="customButton btn btn-success btn-alerts btn-m" onClick={handleConfirm.bind(this)}>Confirmar</button>
			  <button className="customButton btn btn-default btn-alerts btn-m-r" onClick={this.handleClickClose}>Cancelar</button>
			  <span className='s-alert-close' onClick={handleClose}></span>
			</div>
			);
		}
		
		
		
		
	}
	
	
	handleClickAlerta=(event)=>{
		
		
		this.setState({
			estado_pregunta:this.pregunta_estado.value,
			template:true,
			isActive:false
		})
		const customerName = 'Acacya';
		Alert.success('¿Deseas confirmar los cambios?', {
		  position: 'top-right',
		  timeout:'none',		  
		  customFields: {
			customerName: customerName
		  }
		});
		
		event.preventDefault();
	}
  
  
	handleClickClose(){		
		Alert.closeAll();
	}
	
	
	
	
	
	
	componentDidMount(){
		
		
		this.Calificaciones.on('value',this.gotData,this.errData);
		
	}
	
	
	gotData=(data)=>{
	
		
	
		let newCalificaciones=[];
		
		let datacalificaciones=data.val();
		
		
		if(datacalificaciones!==null){
			
			let keys=Object.keys(datacalificaciones);
			
			
			for(let i=0;i<keys.length;i++){
				
				let k=keys[i];
				
				let objCalficaciones=newCalificaciones.find(calificaciones=>calificaciones.tipo===datacalificaciones[k].tipo);
	
				
				if(objCalficaciones===undefined){
					
					newCalificaciones.push({
						
						key:k,
						tipo:datacalificaciones[k].tipo,
						estado:datacalificaciones[k].estado
	
					})				
				}
			}
			this.setState({calificaciones:newCalificaciones});
			
			
		}
		
		
		
	}
	errData=(err)=>{
		
		
		console.log('Error: '+err);
	}
	
	
	toggleModal(){
		
		this.setState({
			isActive:!this.state.isActive,
			preguntasAgregar:[],
			preguntasEliminar:[]
		})
		
	}
	
	
	imgFormatter(cell,row) {
		 
		return  <button className="btn btn-success btn-sm" onClick={() => {this.handleClick(row)}} >Editar</button>;
	}
	
	handleClick(row){

		this.toggleModal();

		this.setState({
			
			estado_pregunta:row.estado
			
		})
	
		this.Calificaciones.orderByChild('tipo').equalTo(row.tipo).on('value',(snapshot)=>{
			
			
			let newCalificaciones=[];
			let data=snapshot.val();
			
			
			if(data!==null){
				
					
					let keys=Object.keys(data);
					
					for(let i=0;i<keys.length;i++){
						
						
						let k=keys[i];
						
						newCalificaciones.push({
							key:k,
							estado:data[k].estado,
							pregunta:data[k].pregunta,
							tipo:data[k].tipo
							
						})
						
						
					}
					this.setState({
						preguntas:newCalificaciones,
						tipo:row.tipo
					});
			}
		})
	}
	
	handleSubmit=()=>{
		
		
		
	
		database.ref().child('Calificaciones').orderByChild('tipo').equalTo(this.state.tipo).on('value',(snapshot)=>{
			
			
			let dataPregunta=snapshot.val();
			
			if(snapshot.exists() && dataPregunta!==null){
				
				let keys=Object.keys(dataPregunta);
				
				for(let i=0;i<keys.length;i++){
					
					let k=keys[i];
					
					database.ref().child('Calificaciones').child(k).update({
							
						estado:this.state.estado_pregunta.toLowerCase()
						
					})
					
					
				}
				
			}
			
		});
	
	
		for(let i=0;i<this.state.preguntasAgregar.length;i++){
			
			this.Calificaciones.push({
				
				estado:this.state.preguntasAgregar[i].estado,
				pregunta:this.state.preguntasAgregar[i].pregunta,
				tipo:this.state.tipo
				
			})
			
		}
	
		//Preguntas a eliminar
		for(let i=0;i<this.state.preguntasEliminar.length;i++){
			
			this.Calificaciones.child(this.state.preguntasEliminar[i].key).remove();
			
		}
	
		
		Alert.success('Datos actualizados correctamente', {
				effect: 'genie',
				position: 'bottom-right',
				timeout:2000			
	    });

		
		
	}
	
	handleClickEliminarPregunta(row){
		
		
		
		if(row.key!=='0'){
			
			this.state.preguntasEliminar.push({
				key:row.key,
				estado:row.estado,
				pregunta:row.pregunta
		
			})			
		}
		
	
		this.setState({
			preguntasEliminar:this.state.preguntasEliminar,
			preguntas:this.state.preguntas.filter(preguntas=>preguntas.pregunta!==row.pregunta),
			preguntasAgregar:this.state.preguntasAgregar.filter(preguntas=>preguntas.pregunta!==row.pregunta)
			
		})
	}
	
	
	handleClickAgregarPregunta(row){
		
		
		let pregunta=this.state.preguntas.find(preguntas=>preguntas.pregunta===this.pregunta.value);
		
		
		
		
	
		if(pregunta===undefined  && this.pregunta.value!==""  && this.state.preguntas.length<5){
			
			this.state.preguntasAgregar.push({
				pregunta:this.pregunta.value,
				estado:'activo',
				tipo:this.state.tipo
				
			})
			
			
			this.state.preguntas.push({
				key:'0',
				pregunta:this.pregunta.value,
				estado:'activo',
				tipo:this.state.tipo
				
				
			})
			
			this.setState({
				
				preguntas:this.state.preguntas
				
			})
			
			this.pregunta.value="";
		}
			
		
		
	}
	
	btnEliminarFormatter(cell,row){
				
		return <p className="glyphicon glyphicon-remove btn-eliminar" onClick={() => {this.handleClickEliminarPregunta(row)}} ></p>
	}
	
	ocultarMenu(){
		

		store.dispatch({
			
			type: 'STATE_MOSTRAR',
			mostrar:'noMostrar'
		})
	}
	
	updateRow=()=>{
		
		
		
	}
	
	
	
	render(){
		
		return(
		
			<div className="calificaciones container" onClick={this.ocultarMenu}>
					
					<h1 className="titulo">Calificaciones</h1>
				
				
				
				{this.state.template ? <Alert  timeout='none' contentTemplate={this.AlertaContenido} />:<Alert stack={{limit: 3}} html={true} />}
				<ModalCalificaciones/>
				

				<BootstrapTable data={ this.state.calificaciones }
					 ref='table'			 
					 pagination={ true }
					 search={ true }
					 hover
					 >
					 <TableHeaderColumn dataField='key' isKey={true} dataSort={true} hidden >Nombre</TableHeaderColumn>
					 <TableHeaderColumn dataField='tipo'  dataSort={true}  >Tipo</TableHeaderColumn>
					 <TableHeaderColumn dataField='estado'  dataSort={true}  >Estado</TableHeaderColumn>
					 <TableHeaderColumn dataField='edit' dataAlign='center' dataFormat={ this.imgFormatter.bind(this) }>Editar</TableHeaderColumn>
				</BootstrapTable>
				  
				  <Modal isOpen={this.state.isActive} onRequestClose={this.toggleModal}  style={customStyles}>
					
				
						<h3>Editar preguntas</h3>
							<hr/>
							<label>Tipo</label>
							<div className="form-group">
								<input type="text" className="form-control" disabled
								defaultValue={this.state.tipo}
								/>
							</div>
							<div className="form-group">
							
								<label>Ingresa una pregunta</label>
								<input type="text" name="pregunta" placeholder="Agrega una nueva pregunta"   
								ref={input=>{this.pregunta=input}} className="form-control"
								/>
								<br/>
									<button className="btn btn-success btn-sm" onClick={this.handleClickAgregarPregunta}>Agregar pregunta</button>	
							</div>
							
							<div className="form-group">
								<label htmlFor="estado">Estado</label>
								<select className="form-control" name="estado"									
									ref={input=>{this.pregunta_estado=input}}
								>
									<option>Activo</option>
									<option>Inactivo</option>
								</select>
							</div>
							
				
				
						
						<form method="POST" action="" onSubmit={this.handleClickAlerta.bind(this)}>
							
		
							<div className="form-group">
								<label>Preguntas</label>
								
								<BootstrapTable data={ this.state.preguntas }
									 ref='table'			 
									 pagination={ false }
									 search={ false }
									 hover
									 >
									 <TableHeaderColumn dataField='key' isKey={true} dataSort={true} hidden >Nombre</TableHeaderColumn>
									 <TableHeaderColumn dataField='pregunta'  dataSort={true}  >Tipo</TableHeaderColumn>
									 <TableHeaderColumn dataField='edit' dataAlign='center' dataFormat={ this.btnEliminarFormatter.bind(this) }>Eliminar</TableHeaderColumn>					
								</BootstrapTable>
							</div>

							<hr/>
							
							<button className="btn btn-primary buttons" type="submit" >Guardar</button>
						</form>
							<button className="btn btn-default buttons btnmargin" onClick={this.toggleModal}>Cerrar</button>
								
				  </Modal>
				  
				  
			
			</div>
		
		);
		
		
	}
	
	
	
}

export default Calificaciones;



// WEBPACK FOOTER //
// ./src/Components/Calificaciones1/Calificaciones.js